/**
 * Calculates the price of a product based on promotional pricing, VIP status,
 * and whether the product is part of a VIP cart.
 *
 * @param {Object} product - The product object containing pricing details.
 * @param {boolean} isVip - A flag indicating if the user is a VIP customer.
 * @param {boolean} isVipCart - A flag indicating if the cart is a VIP cart.
 * @returns {number|null} - The calculated price of the product, or null if product is not provided.
 *
 * Pricing logic:
 * - If a promotional price (`promoPrice`) is available, it is used as the price.
 * - If no promotional price is available:
 *   - If the user is a VIP (`isVip` is true), use `defaultUnitPrice`.
 *   - If the cart is a VIP cart (`isVipCart` is true), use `retailUnitPrice`.
 *   - If neither the user nor the cart is VIP, use `retailUnitPrice`.
 */

import { SecondarySites } from '../constants/secondarySites';

function getCartPrice({ product, isVip, isVipCart, secondarySite }) {
  // this logic completely mirrors the vue logic in https://github.com/Fabletics/web-legacy/pull/1477
  if (!product) {
    return null;
  }

  const {
    defaultUnitPrice,
    promos = {},
    retailUnitPrice,
    outletUnitPrice,
  } = product;
  const { promoPrice } = promos;

  if (secondarySite === SecondarySites.OUTLET) {
    return outletUnitPrice;
  }

  if (isVip) {
    return promoPrice || defaultUnitPrice;
  }

  if (isVipCart) {
    return promoPrice || retailUnitPrice;
  }

  return retailUnitPrice;
}

export default getCartPrice;
